package flagpack.icons.small

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Bosnia and Herzegovina Flag (16x12dp)
 *
 * - ISO Alpha-2: BA
 * - ISO Alpha-3: BIH
 * - ISO Numeric: 070
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Small.BosniaAndHerzegovina: ImageVector by lazy {
    ImageVector.Builder(
        name = "Bosnia and Herzegovina:BA:BIH:070:Small",
        defaultWidth = 16.dp,
        defaultHeight = 12.dp,
        viewportWidth = 16f,
        viewportHeight = 12f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF2E42A5)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                horizontalLineTo(16f)
                verticalLineTo(12f)
                horizontalLineTo(0f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(5f, 0f)
                horizontalLineTo(15f)
                verticalLineTo(12f)
                lineTo(5f, 0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(3.554f, 1.397f)
                lineTo(2.966f, 1.706f)
                lineTo(3.078f, 1.051f)
                lineTo(2.603f, 0.588f)
                lineTo(3.26f, 0.492f)
                lineTo(3.554f, -0.103f)
                lineTo(3.848f, 0.492f)
                lineTo(4.505f, 0.588f)
                lineTo(4.03f, 1.051f)
                lineTo(4.142f, 1.706f)
                lineTo(3.554f, 1.397f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(5.297f, 3.537f)
                lineTo(4.71f, 3.846f)
                lineTo(4.822f, 3.191f)
                lineTo(4.346f, 2.728f)
                lineTo(5.003f, 2.632f)
                lineTo(5.297f, 2.037f)
                lineTo(5.591f, 2.632f)
                lineTo(6.248f, 2.728f)
                lineTo(5.773f, 3.191f)
                lineTo(5.885f, 3.846f)
                lineTo(5.297f, 3.537f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6.932f, 5.619f)
                lineTo(6.344f, 5.928f)
                lineTo(6.456f, 5.274f)
                lineTo(5.981f, 4.81f)
                lineTo(6.638f, 4.715f)
                lineTo(6.932f, 4.119f)
                lineTo(7.226f, 4.715f)
                lineTo(7.883f, 4.81f)
                lineTo(7.407f, 5.274f)
                lineTo(7.519f, 5.928f)
                lineTo(6.932f, 5.619f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(8.533f, 7.615f)
                lineTo(7.945f, 7.924f)
                lineTo(8.057f, 7.269f)
                lineTo(7.582f, 6.806f)
                lineTo(8.239f, 6.71f)
                lineTo(8.533f, 6.115f)
                lineTo(8.827f, 6.71f)
                lineTo(9.484f, 6.806f)
                lineTo(9.008f, 7.269f)
                lineTo(9.12f, 7.924f)
                lineTo(8.533f, 7.615f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(10.257f, 9.668f)
                lineTo(9.669f, 9.977f)
                lineTo(9.782f, 9.323f)
                lineTo(9.306f, 8.859f)
                lineTo(9.963f, 8.764f)
                lineTo(10.257f, 8.168f)
                lineTo(10.551f, 8.764f)
                lineTo(11.208f, 8.859f)
                lineTo(10.733f, 9.323f)
                lineTo(10.845f, 9.977f)
                lineTo(10.257f, 9.668f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(12.163f, 11.656f)
                lineTo(11.576f, 11.965f)
                lineTo(11.688f, 11.31f)
                lineTo(11.212f, 10.847f)
                lineTo(11.87f, 10.751f)
                lineTo(12.163f, 10.156f)
                lineTo(12.457f, 10.751f)
                lineTo(13.115f, 10.847f)
                lineTo(12.639f, 11.31f)
                lineTo(12.751f, 11.965f)
                lineTo(12.163f, 11.656f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun BosniaAndHerzegovinaPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Small.BosniaAndHerzegovina,
            contentDescription = "Bosnia and Herzegovina Flag"
        )
    }
}
